
    <footer class="page-footer">
    
        <div class="service-footer-container footer_margin">
            <div class="service-footer">
                <div class="service-footer__col">
                    <h4>Síguenos</h4>
                    <ul class="follow-us">
                        <li class="follow-us__item"><a href="http://www.facebook.com/Bayer" title="Follow Us on Facebook"  target="_blank" class="follow-us__link follow-us__link--fb">Facebook</a></li>
                        <li class="follow-us__item"><a href="http://twitter.com/bayer"  target="_blank" class="follow-us__link follow-us__link--tw" data-src-title="Follow Us on Twitter">Twitter</a></li>
                        <li class="follow-us__item"><a href="http://www.youtube.com/user/BayerTVinternational" title="Follow Us on YouTube"  target="_blank" class="follow-us__link follow-us__link--yt">YouTube</a></li>
                        <li class="follow-us__item"><a href="http://www.linkedin.com/company/bayer" title="Follow Us on LinkedIn"  target="_blank" class="follow-us__link follow-us__link--li">LinkedIn</a></li>
                        <li class="follow-us__item"><a href="http://instagram.com/bayerofficial" title="Follow Us on Instagram"  target="_blank" class="follow-us__link follow-us__link--ig" data-placement="left">Instagram</a></li>
                        <li class="follow-us__item"><a href="https://www.bayer.com/en/rss.aspx" title="RSS Feed"  target="_blank" class="follow-us__link follow-us__link--rss" data-placement="left">RSS</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="content-footer-container">
            <div class="content-footer">
                <div class="cright-item">Copyright &copy;{{Etiquetas.CopyrightFooter}}</div>
                <div class="sitemap-link"><a href="sitemap.html">Sitemap</a></div>
                <ul class="legaladvice">
                    <li><a href="{{Etiquetas.CondicionesUso.Link}}" target="_blank"  >{{Etiquetas.CondicionesUso.Titulo}}</a></li>
                    <li><a href="{{Etiquetas.PoliticaDePrivacidad.Link}}" target="_blank" >{{Etiquetas.PoliticaDePrivacidad.Titulo}}</a></li>
                    <li><a href="{{Etiquetas.PieDeImprenta.Link}}" target="_blank" >{{Etiquetas.PieDeImprenta.Titulo}}</a></li>
                </ul>
                <div class="printfooter"><!-- REPLACE: current URL --></div>
            </div>
        </div>
     
    </footer>
 